//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState, mapMutations } from 'vuex'
import { local, KEY_USER_TOKEN, KEY_ACTIVITY_RESERVATION_DATE,
  KEY_BOOKED_RESERVATION, KEY_ANNUAL_REPORT_SHOWED_YEARS, KEY_APP_FONT_SIZE,
  KEY_MEDIATEK_2025GIVINGTREE_TOKEN, KEY_MEDIATEK_2025GIVINGTREE_USER_INFO, session } from '@/tools/storage'
import ZombieWaringModal from '@/components/modal/ZombieWaringModal'
import ActivityReservation from '@/components/modal/ActivityReservation'
import VerifyCellphoneModal from '@/components/modal/VerifyCellphoneModal'
import WelcomeModal from '@/components/modal/WelcomeModal'
import configApi from '@/store/apis/config'
import { getQueryParam } from '@/tools/axios'
import openInAppMixin from '@/mixins/openInApp'
import isBefore from 'date-fns/is_before'
import { ANNUAL_REPORT_YEAR, USER_STATUS, ANNUAL_REPORT_SHOW_START_TIME, ANNUAL_REPORT_SHOW_END_TIME } from '@/tools/constant'
import EarthDayInviteModal from '@/components/modal/EarthDayInviteModal'
// import { FESTIVAL_SOCIAL_WORK_DAY_2026, FESTIVAL_EARTH_2026 } from '@/tools/AppConfig'
import isAfter from 'date-fns/is_after'

export default {
  name: 'App',
  mixins: [openInAppMixin],
  components: {
    ZombieWaringModal,
    ActivityReservation,
    VerifyCellphoneModal,
    WelcomeModal,
    EarthDayInviteModal
  },
  data () {
    return {
      showReservationModal: true
    }
  },
  created () {
    window.addEventListener('offline', () => {
      this.$vux.toast.show({
        position: 'middle',
        text: '當前網路不穩定或已離線',
        type: 'cancel',
        time: 4000
      })
    })

    this.getConfigVersion()

    // 刷新頁面請求訊息狀態

    let token = local.get(KEY_USER_TOKEN)
    if (token) {
      this.setToken({token})
    } else {
      // const tokenCookie = Cookies.get('token')
      // if (tokenCookie) {
      //   token = tokenCookie
      //   local.save(KEY_USER_TOKEN, tokenCookie)
      //   this.setToken({token})
      // }
    }

    if (token && !(typeof this.msgStatus === 'boolean') && !window.location.href.match(/localhost/)) {
      this.getMessageStatus()
    }

    let mediatekToken = session.get(KEY_MEDIATEK_2025GIVINGTREE_TOKEN)
    if (mediatekToken) {
      this.setMediatekToken(mediatekToken)
      let mediatekUserInfo = session.get(KEY_MEDIATEK_2025GIVINGTREE_USER_INFO, true)
      if (mediatekUserInfo) {
        this.setMediatekUserInfo(mediatekUserInfo)
      }
    }

    // this.getWelfareAwardInfo(WELFARE_AWARD_YEAR)
    // this.getWishTimes()
    // this.getEarthdayFestivalDetail({ id: FESTIVAL_EARTH_2026 })
    //   .catch(err => {
    //     console.log(err)
    //   })

    // this.getFestivalDetail({ id: FESTIVAL_SOCIAL_WORK_DAY_2026 })
    //   .catch(err => {
    //     console.log(err)
    //   })

    if (!this.mobileType) {
      let type = ''
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        type = 'ios'
      } else if (/(Android)/i.test(navigator.userAgent)) {
        type = 'android'
      } else {
        type = 'pc'
      }
      this.setMobileType({type})
    }
    if (token) {
      if (!this.userId) {
        this.getLoginUserInfo({cb: this.loginCb})
      }
      this.getAccountRisk()
    } else {
      if (this.$route.query.annual_report ||
          (!local.hasValue(KEY_ANNUAL_REPORT_SHOWED_YEARS, ANNUAL_REPORT_YEAR) &&
            localStorage.getItem('isShow') && isAfter(new Date(), ANNUAL_REPORT_SHOW_START_TIME) &&
            isBefore(new Date(), ANNUAL_REPORT_SHOW_END_TIME))) {
        this.$annualReport.show()
        local.pushValue(KEY_ANNUAL_REPORT_SHOWED_YEARS, ANNUAL_REPORT_YEAR)
      }
    }

    if (!localStorage.getItem('isShow')) {
      this.showReservationModal = false
    }
  },
  mounted () {
    const fontSize = local.get(KEY_APP_FONT_SIZE) || 16
    if (fontSize) {
      document.documentElement.style.fontSize = fontSize + 'px'
    }

    window.openLink = (url) => {
      if (!url) { return }
      if (url.startsWith('https://www.give543.com/static/') ||
        url.startsWith('https://m.give543.com/static/') ||
        url.startsWith('https://www.give-circle.com/static/') ||
        url.startsWith('https://m.give-circle.com/static') ||
        url.startsWith('https://m.qa.give543.com/static/')) {
        window.open(url, '_blank')
        return
      }

      if (url.startsWith('/')) {
        if (url === '/' || url === '/gifts' || url === '/needs') {
          this.$router.replace(url)
        } else {
          this.$router.push(url)
        }
        return
      }

      if (url.startsWith('https://api.give543.com/api/share/') ||
          url.startsWith('https://qa-api.give543.com/api/share/')) {
        this.openNewShareUrl(url)
        return
      }

      if (url.startsWith('https://api.give543.com/api/shares/') ||
          url.startsWith('https://qa-api.give543.com/api/shares/')) {
        this.openSharesUrl(url)
        return
      }

      let newUrl
      newUrl = url.replace('www.give543.com', 'm.give543.com')
        .replace('https://qa.give543.com', 'https://m.qa.give543.com')
        .replace('www.give-circle.com', 'm.give-circle.com')

      let matches = ['https://m.give543.com', 'http://m.give543.com',
        'https://m.qa.give543.com', 'm.give543.com', 'https://m.give-circle.com']

      for (let match of matches) {
        if (newUrl.indexOf(match) === 0) {
          let navUrl = newUrl.substring(match.length)
          if (!navUrl || navUrl === '/' || navUrl === '/gifts' || navUrl === '/needs') {
            this.$router.replace(navUrl)
          } else {
            let newNavUrl = navUrl.replace('give', 'gift')
              .replace('want', 'need')
              .replace('stories', 'story')
              .replace('love/', 'lovebox/')
            this.$router.push(newNavUrl)
          }
          return
        }
      }

      window.open(url, '_blank')
    }

    let source = getQueryParam(location.search, 'utm_source')
    if (source) {
      this.setUtmSource(source)
    }

    this.$ga.trackEvent('app', 'active', source)

    if (navigator.userAgent.match(/(iPhone|iPod|ios|iPad)/i) &&
      !window.location.href.match(/localhost/) &&
      !window.location.pathname.startsWith('/verifyemail') &&
      !window.location.pathname.startsWith('/confirm/') &&
      !window.location.pathname.startsWith('/login') &&
      !window.location.pathname.startsWith('/bindCarbonLabelling') &&
      !window.location.pathname.startsWith('/welfare/bindEnterprises') &&
      !window.location.pathname.startsWith('/wpgwishes') &&
      !window.location.pathname.startsWith('/makalot-wishes') &&
      !window.location.pathname.startsWith('/wish/') &&
      !window.location.pathname.startsWith('/companyPage/') &&
      !window.location.pathname.startsWith('/mediatek-2026givingtree')) {
      this.$vux.confirm.show({
        title: '是否打開贈物網App查看',
        confirmText: '確定',
        cancelText: '取消',
        onCancel: () => {
        },
        onConfirm: () => {
          this.openInApp(this.$route.fullPath)
        }
      })
    }
  },
  methods: {
    ...mapActions({
      getLoginUserInfo: 'getLoginUserInfo',
      getMessageStatus: 'getMessageStatus',
      logoutCommit: 'logout',
      resetUserInfo: 'resetLoginUserInfo',
      getConfigVersion: 'getConfigVersion',
      getWishTimes: 'getWishTimes',
      getAccountRisk: 'getAccountRisk',
      getWelfareAwardInfo: 'getWelfareAwardInfo',
      getFestivalDetail: 'getFestivalDetail',
      getEarthdayFestivalDetail: 'getEarthdayFestivalDetail'
    }),
    ...mapMutations({
      setToken: 'setToken',
      setMobileType: 'setMobileType',
      showLoginWelcome: 'showLoginWelcome',
      showInviteDialog: 'showInviteDialog',
      setUtmSource: 'setUtmSource',
      setMediatekToken: 'mediatek/setToken',
      setMediatekUserInfo: 'mediatek/setUserInfo'
    }),
    loginCb (data) {
      if (data && data.user_restriction &&
        (data.user_restriction.type === 'DISABLE')) {
        this.logoutCommit()
        this.resetUserInfo()
        // 登出時清除輪詢定時器
        let localReadInterval = local.get('READ_INTERVAL', true)
        if (localReadInterval) {
          window.clearInterval(localReadInterval)
          localReadInterval = null
          local.remove('READ_INTERVAL')
        }
        this.$router.replace(`/login?redirect=/&tips=${data.user_restriction.type === 'DISABLE' ? '當前帳號已被暫停使用' : '系統出錯，暫時無法登入'}`)
      } else if (data && data.user_restriction &&
        (data.user_restriction.type === 'CLOSED')) {

      } else {
        if (this.$route.query.annual_report) {
          this.$annualReport.show(data.id)
          local.pushValue(KEY_ANNUAL_REPORT_SHOWED_YEARS, ANNUAL_REPORT_YEAR)
        } else if (!local.hasValue(KEY_ANNUAL_REPORT_SHOWED_YEARS, ANNUAL_REPORT_YEAR) && localStorage.getItem('isShow')) {
          if (isBefore(data.createtime, '2026/01/01') && isAfter(new Date(), ANNUAL_REPORT_SHOW_START_TIME) &&
            isBefore(new Date(), ANNUAL_REPORT_SHOW_END_TIME)) {
            this.$annualReport.show(data.id)
            local.pushValue(KEY_ANNUAL_REPORT_SHOWED_YEARS, ANNUAL_REPORT_YEAR)
          }
        }
      }
    },
    closeActivity () {
      this.showReservationModal = false
    },
    openSharesUrl (url) {
      let param = url.substring(url.indexOf('/shares/') + '/shares/'.length)
      param = parseInt(param)
      if (param) {
        configApi.getShareInfo(param)
          .then(res => {
            if (res.url) {
              window.openLink(res.url)
            }
          })
          .catch(() => {
            window.open(url, '_blank')
          })
      } else {
        window.open(url, '_blank')
      }
    },
    openNewShareUrl (url) {
      let objectId = getQueryParam(url, 'id')
      let type = url.substring((url.indexOf('/share/') + '/share/'.length), url.indexOf('?'))
      this.$router.push(`/${type}/${objectId}`)
    },
    closeWelcomeModal () {
      this.showLoginWelcome({ visible: false })
    },
    closeInviteDlg () {
      this.showInviteDialog({ visible: false })
    }
  },
  computed: {
    ...mapState({
      msgStatus: state => state.user.msgStatus,
      mobileType: state => state.configs.mobileType,
      userInfo: state => state.user.userInfo,
      userId: state => state.user.userInfo.id,
      frozen: state => state.user.userInfo.frozen, // 逾期未取被冰凍
      fronzenTimes: state => state.user.userInfo.frozenTimes,
      activities: state => state.things.activities.data,
      userRestriction: state => state.user.userInfo.userRestriction,
      isAccountRisk: state => state.user.isAccountRisk,
      loginWelcomeVisible: state => state.home.loginWelcomeVisible,
      loginDays: state => state.home.loginDays,
      inviteDlgVisible: state => state.home.inviteDlgVisible,
      utmSource: state => state.configs.utmSource
    }),
    warningModelType () {
      if (this.userInfo.status === USER_STATUS.INACTIVE) {
        return 'inactive'
      } else if (this.frozen) {
        return 'frozen'
      } else if (this.userRestriction && (this.userRestriction.type === 'DISABLE')) {
        return 'disable'
      } else if (this.userRestriction && (this.userRestriction.type === 'CLOSED')) {
        return 'closed'
      }
      return ''
    },
    showWarningModel () {
      if (this.$route.path === '/dealsReq/sent' ||
        this.$route.path === '/feedback') {
        return false
      }

      if (this.$route.path.startsWith('/chatroom/') ||
        this.$route.path.startsWith('/thanksItem/')) {
        return false
      }

      return !!this.warningModelType
    },
    reservationActivities () {
      if (!this.activities.length) {
        return []
      }

      let reservationArray = local.get(KEY_BOOKED_RESERVATION) || ''

      let activities = []
      for (let activity of this.activities) {
        if (reservationArray.indexOf(activity.id) === -1 && !activity.is_booked) {
          activities.push(activity)
        }
      }

      return activities
    },
    isShowReservation () {
      if (!this.showReservationModal) {
        return false
      }

      if (!this.reservationActivities.length) {
        return false
      }

      const reservatonDate = local.get(KEY_ACTIVITY_RESERVATION_DATE)
      const today = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`
      if (!reservatonDate) {
        local.save(KEY_ACTIVITY_RESERVATION_DATE, today)
        return true
      }

      if (reservatonDate === today) {
        return false
      }

      local.save(KEY_ACTIVITY_RESERVATION_DATE, today)
      return true
    }
  }
}
